export enum PaymentMethod {
  StripeCard = 's_card',
  StripeSEPA = 's_sepa',
  StripeBACS = 's_bacs',
  StripePayPal = 's_paypal',
  StripeIdeal = 's_ideal',
  GoCardlessDirectDebit = 'gc_direct-debit',
}
